export default __webpack_public_path__ + "static/media/2.a3da6d8f.jpg";